<div class="mb-4">
  <p-table
    [value]="securities"
    [paginator]="false"
    [tableStyle]="{ 'min-width': '50rem' }"
    dataKey="asReportedSecurityId"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>A R. Id</th>
        <th>Filing ID</th>
        <th>Security Type</th>
        <th>Issuer Name</th>
        <th>URL</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-product>
      <tr>
        <td>{{ product.asReportedSecurityId || "N/A" }}</td>
        <td>{{ product.filingId || "N/A" }}</td>
        <td>{{ product.asReportedSecurityType || "N/A" }}</td>
        <td>{{ product.asReportedIssuerName || "N/A" }}</td>
        <td>
          <a href="{{ product.xbrl }}" *ngIf="product.xbrl" target="_blank"
            >Link</a
          >
          <span *ngIf="!product.xbrl">-</span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
<div
  class="grid gap-6 my-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 border border-gray-200 rounded-lg p-6 bg-white"
>
  <!-- Security Type Dropdown -->

  <div class="relative z-0 w-full mb-5 group">
    <p-dropdown
      [options]="securityTypes"
      [(ngModel)]="formData.selectedSecurityType"
      (onChange)="onSecurityTypeChange()"
      optionLabel="label"
      appendTo="body"
      editable="true"
      inputId="securityTypeDropdown"
      [styleClass]="'w-full border-0 border-b-2 border-gray-300 p-2'"
      placeholder="Select or type security type..."
      [panelStyleClass]="'custom-dropdown-panel'"
      (keydown)="preventSpaceKey($event)"
      (paste)="onPaste($event, 'asReportedSecurityType')"
    ></p-dropdown>
    <label
      for="securityTypeDropdown"
      class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform left-0 -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
    >
      Security Type
    </label>
  </div>

  <!-- CFI Code Input -->
  <div class="relative z-0 w-full mb-5 group">
    <input
      type="text"
      name="cfiCode"
      [(ngModel)]="formData.cfiCode"
      class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#1f273b] peer"
      placeholder=" "
      (keydown)="preventSpaceKey($event)"
      (paste)="onPaste($event, 'cfiCode')"
    />
    <label
      class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-[#1f273b] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
    >
      CFI Code
    </label>
  </div>
</div>
<div class="button-group flex justify-end py-3 space-x-2">
  <button
    class="bg-[#1f273b] text-white hover:bg-[#1f273b] text-6ray-800 py-1 px-3 cursor-pointer border border-[#d9d9d9] rounded"
    (click)="onSubmit()"
    [disabled]="!formData.asReportedSecurityType || !formData.cfiCode"
  >
    Map
  </button>
  <button
    class="bg-white hover:bg-gray-100 text-6ray-800 py-1 px-3 cursor-pointer border border-[#d9d9d9] rounded"
    (click)="onCancel()"
  >
    Cancel
  </button>
</div>
<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
